import { StripeElementsUpdateOptions } from '@stripe/stripe-js';
import { getCssVariable } from '@/utils/commons';

export const frenchTerritories = ['FR', 'RE', 'MQ', 'GP', 'PM', 'PF'];

export const getStripeAppearance = (): StripeElementsUpdateOptions['appearance'] => ({
  theme: 'stripe',
  variables: {
    fontFamily: 'Inter, sans-serif',
    fontSizeBase: '14px',
    fontWeightNormal: '400',
    fontWeightMedium: '500',
    colorBackground: getCssVariable('--background'),
    colorText: getCssVariable('--card-foreground'),
    colorPrimary: getCssVariable('--primary'),
    colorTextSecondary: getCssVariable('--secondary-foreground'),
    colorDanger: getCssVariable('--destructive'),
  },
  rules: {
    '.Input': {
      height: '2.5rem', // h-10
      width: '100%',
      borderRadius: '0.375rem',
      fontSize: '14px',
    },
    '.Label': {
      fontWeight: '500',
      fontSize: '14px',
      marginBottom: '0.25rem',
      lineHeight: '1.5',
    },
    '.TermsText': {
      fontSize: '12px',
      fontLineHeight: '1',
    },
  },
});

export const stripePriceIds: Record<'live' | 'dev', { monthly: string; yearly: string }> = {
  live: {
    monthly: 'price_1RlR2eBQyJjVmkNKGEH5af2r',
    yearly: 'price_1RlR2eBQyJjVmkNKeApRA8J9',
  },
  dev: {
    monthly: 'archireport_pro_monthly_2024',
    yearly: 'archireport_pro_yearly_2024',
  },
};

export const stripeEnv: keyof typeof stripePriceIds = import.meta.env.VITE_STRIPE_PUBLIC_KEY?.includes('live')
  ? 'live'
  : 'dev';
